import {withTableBody} from './withTableBody';
import {TableBodyStyle} from './TableBodyStyle';

/**
 * Represents table body group. Typically contains row with data cells.
 *
 * @component
 */
export const TableBody = withTableBody(TableBodyStyle);
